import AndroidWifiErrorModal from '@/components/MedicalDepartureWifi/AndroidWifiErrorModal';
import IosWifiErrorModal from '@/components/MedicalDepartureWifi/IosWifiErrorModal';
import React, { useState } from 'react';

type Props = {
  isAndroid?: boolean;
  onOpenResolveModal?: () => void;
  place?: 'airport' | 'port';
};

function useWifiErrorModal({
  isAndroid = false,
  onOpenResolveModal = () => {},
  place = 'airport',
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const onOpenModal = () => {
    setIsOpen(true);
  };

  const Modal = isOpen ? (
    isAndroid ? (
      <AndroidWifiErrorModal onClose={() => setIsOpen(false)} place={place} />
    ) : (
      <IosWifiErrorModal
        onClose={() => setIsOpen(false)}
        onOpenResolve={onOpenResolveModal}
      />
    )
  ) : null;

  return {
    onOpenModal,
    Modal,
  };
}

export default useWifiErrorModal;
